import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { isBoolean, cloneDeep } from 'lodash';
import HoverImage from 'react-hover-image/build';
import { useNavigate } from 'react-router-dom';
import { cellRendererCheck, cellRendererToolTip, dateFormate, faxColumns } from 'utils/columns';
import FaxViewer from 'components/FaxViewer';
import ReactStrapTable from 'components/reactStrapTable';
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import RefreshIcon from 'assets/icon/refresh-icon.svg';
import RefreshIconHover from 'assets/icon/refresh-icon-hover.svg';
import { toast } from 'react-toastify';
import useAxios from 'hooks/useAxios';
import FaxForwardicon from 'assets/icon/faxforward.jpg';
import { ModuleAccess } from 'utils/moduleaccess';
import Drawer from 'components/Drawer';
import NPIPorviderEdit from 'components/NPIPorviderEdit';
import collapse from "assets/icon/collapse-icon.svg";
import collapseclose from "assets/icon/collapse-icon-close.svg";

const FaxTable = ({
  data,
  totalRecords,
  filters,
  onPageChange,
  onSearchColumnFilters,
  refetch,
  orgId,
  onExport,
  selectedCoveredEntity,
  toggleSider,
  collapseSider,
  showpatientdetails,
  setShowPatientDetails,
  patientIDNAME,
  setPatientIdName,
  resetFlag,
  SetResetFlag

}) => {
  const [state, updateState] = useState({
    loading: false,
    isOpen: false,
    canMap: false,
    faxID: '',
    fax: {},
    authFaxNumber: '',
    isForwardFaxOpen: false
  });

  const API = useAxios();
  const navigate = useNavigate();
  const { isOpen, isForwardFaxOpen, fax } = state;
  const [isOpenProvider, setIsOpenProvider] = useState(false);
  const [providerId, setProviderId] = useState('');
  const [faxColFilter, setFaxColFilter] = useState([]);
  const { coveredEntityID, tenantID } = selectedCoveredEntity;
  const [forwardFax, setForwardFax] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  useEffect(() => {
    setHasExportPermission(ModuleAccess("FAX", "EXP"));
  }, []);

  const onHandleRefreshFax = async (fax) => {
    let { tenantID } = selectedCoveredEntity;
    try {
      var payload = {};
      payload.faxDetailID = fax.faxID;
      await API.post(`/${tenantID}/Fax/faxretry`, payload, {
        hideLoader: true,
      });
      toast.success('Fax retry updated successfully');
      refetch();
    } catch (error) {
      console.log('errpr ====>> ', error);
    }
  }
  useEffect(() => {
    updateState([]);
  }, [orgId])


  const toggleDrawer = () => {
    setIsOpenProvider(!isOpenProvider);

  };
  const handleProviderNPI = ({ providerNPI }) => {
    setIsOpenProvider(!isOpenProvider);
    setProviderId(providerNPI);
  };
  const previewFax = (fax) => {
    console.log(fax);
    const { canView } = fax;
    if (!canView) {
      return (
        <div className='d-flex align-items-center'>
          <Button hidden={!(fax.faxStatusID == 180005 || fax.faxStatusID == 180003 || fax.faxStatusID == 180011)}
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => onHandleRefreshFax(fax)}
          >
            <HoverImage
              key='RefreshIcon'
              src={RefreshIcon}
              hoverSrc={RefreshIconHover}
              alt=''
            />
          </Button>

        </div>
      );

    }
    return (
      <div className='d-flex align-items-center'>
        <Button
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => onHandlePreviewFax(fax)}
        >
          <HoverImage
            key='EyeIcon'
            src={EyeIcon}
            hoverSrc={EyeIconHover}
            alt=''
          />
        </Button>
        <Button hidden={!(fax.faxStatusID == 180013)}
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => onHandleForwardedFax(fax)}
        >
          <HoverImage
            key='FaxForwardicon'
            src={FaxForwardicon}
            hoverSrc={FaxForwardicon}
            alt=''
          />
        </Button>

        <Button hidden={!(fax.faxStatusID == 180005 || fax.faxStatusID == 180003 || fax.faxStatusID == 180011)}
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => onHandleRefreshFax(fax)}
        >
          <HoverImage
            key='RefreshIcon'
            src={RefreshIcon}
            hoverSrc={RefreshIconHover}
            alt=''
          />
        </Button>

      </div>
    );
  };

  const onHandlePreviewFax = (fax) => {
    setState({
      isOpen: true,
      fax,
    });
  };
  const onHandleForwardedFax = (fax) => {
    setForwardFax(true)
    setState({
      isForwardFaxOpen: true,
      fax,
    });
  };
  const hasPermission = (code) => {
    return ModuleAccess("CLM", code);
    //return (module && module.actions.indexOf(code) != -1)
  }
  const cellRenderProviderNPI = (row) => {
    const { providerNPI } = row;
    if (providerNPI) {
      if (hasPermission('PRD'))
        return (
          <span
            className='cursor-pointer text-decoration-underline'
            onClick={() => handleProviderNPI(row)}
          >
            {providerNPI}
          </span>
        );
      return (
        <span>
          {providerNPI}
        </span>
      );

    }
    return '-';
  };
  useEffect(() => {
    if (isOpenProvider == true) {
      setIsOpenProvider(false)
    }

  }, [orgId])
  const formatter = (row) => {


    const { patientID, patientFirstName } = row;
    return (
      <span
        className='cursor-pointer text-decoration-underline'
        onClick={() => handlClick(patientID)}
      >
        {patientFirstName}
      </span>
    );
  };

  const handlClick = (id) => {
    // const { coveredEntityID, tenantID } = selectedCoveredEntity;
    setShowPatientDetails(true)
    setPatientIdName(id)
    // navigate(`/claims-manager/${coveredEntityID}/${tenantID}/${false}/patient/${id}`);
  };

  let copyfaxColumns = cloneDeep(faxColumns);
  copyfaxColumns[3].cellRenderer = cellRenderProviderNPI;
  copyfaxColumns = copyfaxColumns.slice(1);
  let columns = [
    {
      dataField: 'edit',
      text: 'Options',
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => previewFax(row),
    },
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => formatter(row),
    },

    // {
    //   dataField: 'patientFirstName',
    //   text: 'Patient First Name',
    //   sort: true,
    //   width: 140,
    //   show: true,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   cellRenderer: (row) => cellRendererCheck(row.patientFirstName),
    // },
    {
      dataField: 'patientLastName',
      text: 'Patient Last Name',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.patientLastName),
    },
    {
      dataField: 'patientDOB',
      text: 'Patient DOB',
      sort: false,
      width: 140,
      show: true,
      inputType: 'date',
      cellRenderer: (row) => dateFormate(row.patientDOB),
    },
    {
      dataField: 'providerNPI',
      text: 'Provider NPI',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRenderProviderNPI(row),
    },
    {
      dataField: 'providerFirstName',
      text: 'Provider First Name',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.providerFirstName),
    },
    {
      dataField: 'providerLastName',
      text: 'Provider Last Name',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.providerLastName),
    },
    {
      dataField: 'fromFaxNumber',
      text: 'From Fax Number',
      sort: true,
      width: 170,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.fromFaxNumber),
    },
    {
      dataField: 'toFaxNumber',
      text: 'To Fax Number',
      sort: true,
      width: 150,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.toFaxNumber),
    },
    {
      dataField: 'direction',
      text: 'Direction',
      sort: false,
      width: 120,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.direction),
    },
    {
      dataField: 'faxStatus',
      text: 'Fax Status',
      sort: false,
      width: 130,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererToolTip(row),
    },
    {
      dataField: 'retryCount',
      text: 'Retry Count',
      sort: true,
      width: 130,
      show: true,
      inputType: 'number',
      cellRenderer: (row) => cellRendererCheck(row.retryCount),
    },
    {
      dataField: 'comments',
      text: 'Comments',
      sort: false,
      width: 140,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.comments),
    },
    {
      dataField: 'forwardCEComments',
      text: 'Forwarded CE Comments',
      sort: false,
      width: 145,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.forwardCEComments),
    },
    {
      dataField: 'createdBy',
      text: 'Created By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.createdBy),
    },
    {
      dataField: 'createdDate',
      text: 'Created Date',
      sort: true,
      width: 140,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.createdDate),
    },
    {
      dataField: 'modifiedByID',
      text: 'Modified By',
      sort: false,
      width: 125,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
    },
    {
      dataField: 'modifiedDate',
      text: 'Modified Date',
      sort: true,
      width: 150,
      show: true,
      inputType: 'date',
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
    {
      dataField: 'apiFaxStatus',
      text: 'API Fax Status',
      sort: true,
      width: 150,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.apiFaxStatus),
    },
    {
      dataField: 'apiPageCount',
      text: 'API Page Count',
      sort: true,
      width: 120,
      show: true,
      inputType: 'number',
      cellRenderer: (row) => cellRendererCheck(row.apiPageCount),
    },
    {
      dataField: 'apiPageComplete',
      text: 'API Page Complete',
      sort: true,
      width: 150,
      show: true,
      inputType: 'number',
      cellRenderer: (row) => cellRendererCheck(row.apiPageComplete),
    },
    {
      dataField: 'apiFaxDirection',
      text: 'API Fax Direction',
      sort: true,
      width: 165,
      show: true,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.apiFaxDirection),
    },
    {
      dataField: 'apiFaxCreatedAt',
      text: 'API Fax Created At',
      sort: true,
      width: 175,
      show: true,
      inputType: 'date',
      cellRenderer: (row) => dateFormate(row.apiFaxCreatedAt),
    },
    {
      dataField: 'validUpto',
      text: 'Valid Upto',
      sort: false,
      width: 150,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.validUpto)
    },
    {
      dataField: 'apiForwardFaxStatus',
      text: 'API Forward Fax Status',
      sort: false,
      width: 170,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.apiForwardFaxStatus),
    },
    {
      dataField: 'forwardFaxNumber',
      text: 'Forward Fax Number',
      sort: false,
      width: 150,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.forwardFaxNumber),
    }

    // ...copyfaxColumns,
  ];

  // const onPageSizeChange = (pageFilter) => {
  //   let filter = {};
  //   filter.currentPage = pageFilter.currentPage;
  //   filter.filters = faxColFilter;
  //   if (pageFilter.pageSize)
  //     filter.pageSize = pageFilter.pageSize;
  //   onPageChange(filter);
  // };
  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    else { onPageChange({ ...filters, currentPage: filter.currentPage, pageSize: filter.pageSize }); }
    // onPageChange(filter);
  };
  const handleSort = (sortFilter) => {
    onPageChange({ ...filters, ...sortFilter });
  };

  const handleSearchColumnFilters = (colFilter) => {
    setFaxColFilter(colFilter);
    onSearchColumnFilters(colFilter);
  };

  const handleFilterCancel = () => {
    refetch(true);
  };

  const togglePdfModal = (hasRefresh, hasCommentRefresh = false) => {
    if (isBoolean(hasCommentRefresh) && hasCommentRefresh) {
      refetch();
    }
    else {
      if (isBoolean(hasRefresh) && hasRefresh) {
        refetch();
      }
      setState({
        isOpen: !isOpen,
      });
    }
  };

  const togglefax = () => {
    setForwardFax(false)
    setState({
      isForwardFaxOpen: !isForwardFaxOpen,
    });
  }
  const refreshComments = () => {
    refetch();
  };



  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="">
          <h5 className="f-16 text-primary font-weight-700 mb-0">
            Fax Count ({totalRecords})
          </h5>
        </div>
        <div>
          <Row>
            <Col xs="auto">
              <div
                className="togglesider ps-3 ms-3 "
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <hr />

      <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id='location-table'
          fixedColumn
          data={data}
          hasPagination
          columns={columns}
          pageSize={filters.pageSize}
          filters={filters}
          totalRecords={totalRecords}
          currentPage={filters.currentPage}
          handleSort={handleSort}
          onPageChange={onPageSizeChange}
          onExport={onExport}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          resetFlag={resetFlag}
          SetResetFlag={SetResetFlag}
          hasExportPermission={hasExportPermission}
        />
        {/* <FaxViewer
          fax={fax}
          isOpen={isOpen}
          toggle={togglePdfModal}
          refreshComments={refreshComments}
          selectedCoveredEntity={selectedCoveredEntity}
        /> */}

        <Drawer
          direction='end'
          isOpen={isOpen}
          toggle={togglePdfModal}
          title="Fax View"
          size="lg"
          className="lg"
        >
          <FaxViewer
            // tenantID={tenantID}
            // providerId={providerId}
            // coveredEntityID={coveredEntityID}
            // onClose={toggleDrawer}

            fax={fax}
            // isOpen={isOpen}
            toggle={togglePdfModal}
            refreshComments={refreshComments}
            selectedCoveredEntity={selectedCoveredEntity}
          />
        </Drawer>


        <Drawer
          direction='end'
          isOpen={isOpenProvider}
          toggle={toggleDrawer}
          title={`${'Update Provider (' + providerId + ')'
            }`}
        >
          <NPIPorviderEdit
            tenantID={tenantID}
            providerId={providerId}
            coveredEntityID={coveredEntityID}
            onClose={toggleDrawer}
          />
        </Drawer>
        {/* 
        <FaxViewer
          fax={fax}
          isOpen={isForwardFaxOpen}
          forwardFax={true}
          toggle={togglefax}
          refreshComments={refreshComments}
          selectedCoveredEntity={selectedCoveredEntity}
        /> */}

      </div>
    </div>
  );
};

export default FaxTable;
